import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import { first } from "rxjs/operators";
import * as firebase from 'firebase/app';
import * as moment from 'moment';

import { IJob, IJobStaff } from './../../interfaces/jobs';
import { IRating, ISkillsRating } from './../../interfaces/ratings';


@Injectable()
export class RatingsProvider {
  constructor(private db: AngularFirestore) {}

  createStaffRating(rating: IRating) {
    rating.id = this.db.createId();
    const ratingRef = this.db.doc(`ratings/${rating.id}`);
    ratingRef.set(rating);
    return ratingRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  getUserRatings(uid: string): Observable<IRating[]> {
    return this.db
      .collection<IRating>('ratings', ref => ref.where('userId', '==', uid))
      .valueChanges();
  }

  getUserRatingsByStaffType(
    uid: string,
    staffTypeId: string
  ): Observable<IRating[]> {
    return this.db
      .collection<IRating>('ratings', ref =>
        ref.where('userId', '==', uid).where('staffTypeId', '==', staffTypeId)
      )
      .valueChanges();
  }

  getUserSkillsRatingsPromise(uid: string): Promise<ISkillsRating> {
    return this.db
      .doc<ISkillsRating>(`skillRatings/${uid}`)
      .valueChanges()
      .pipe(first())
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/ratings/ratings.ts